import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import $ from 'jquery';

import Popup from 'views/shared/ui/popup';
import { t } from 'services/translation';

const Addons = ({ addons }) => {
  const tooltipField = useRef(null);
  const content = `${t('EXTRA_ACTIVITIES')}/${t('SERVICES_OFFERED')}.\n${t(
    'AVAILABLE_DURING_CHECKOUT'
  )}.`;
  const target = '.TourPage-Glance-Addons-help';

  const renderPopup = () => {
    return (
      <Popup
        on="manual"
        reference={tooltipField}
        content={content}
        target={target}
      />
    );
  };

  // The semantic-ui popup doesn't have the option to open the Popup with multiple
  // triggers. The documentation says the trigger event can be "either focus, click,
  // hover, or manual" https://semantic-ui.com/modules/popup.html#/settings
  //
  // While focus works for clicking/tabbing on desktop, it doesn't work for
  // clicking/tapping on a mobile device. https://anyroad.atlassian.net/browse/PE-4390
  //
  // Eventually we'd like to replace uses of semantic-ui/jquery like this, but
  // as a temporary workaround we can manually trigger the popup on focus/blur and
  // click.
  //
  // Since clicking on desktop calls both focus/blur and click events, we also
  // need to throttle to prevent calling popup multiple times per event which
  // causes the popup transition to jitter.
  //
  const throttlePopup = useMemo(
    () =>
      throttle(
        (behavior) => {
          $(target).popup(behavior); // https://semantic-ui.com/modules/popup.html#behavior
          tooltipField.current.focus();
        },
        100,
        { leading: true, trailing: false }
      ),
    []
  );

  return (
    <div className="ui row TourPage-Glance-Addons">
      <div className="center aligned four wide column">
        <button
          type="button"
          className="TourPage-Glance-Addons-help"
          aria-label="Extras offered tooltip"
          onFocus={() => throttlePopup('show')}
          onBlur={() => throttlePopup('hide')}
          onClick={() => throttlePopup('toggle')}
        >
          <i
            className="icon af-help-circle brand-color"
            data-testid="extra-offered-icon"
          />
          {t('EXTRAS_OFFERED')}
        </button>
      </div>
      <div className="left aligned eight wide column">{addons}</div>
      {renderPopup()}
    </div>
  );
};
Addons.displayName = 'TourPage-Glance-Addons';
Addons.propTypes = {
  addons: PropTypes.string.isRequired,
};
export default Addons;
